/**
 * Converts a URL pathname to a human-readable page name.
 * e.g. "/choose-installment" -> "Choose Installment", "/" -> "Home"
 */
export const getPageName = (pathname: string): string => {
    const trimmed = pathname.replace(/^\/+|\/+$/g, '')
    if (!trimmed) return 'Home'

    return trimmed
        .split('/')
        .map((segment) =>
            segment
                .split('-')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' '),
        )
        .join(' / ')
}
